import {
  Mapping,
  MappingLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isMappingLabel,
} from 'src/containers/ProjectDiagram/utils/data';
import { getLabelKeyFromMappingKey } from 'src/containers/ProjectDiagram/utils/mapping/createMappingLabel';
import { doMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doMappingUpdated';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

/** sets `text` on Mapping */
export const setMappingText =
  ({ key, text }: { key: string; text: Mapping['text'] }) =>
  (model: Model) => {
    // update link
    const mapping = model.linkDataArray.find(
      (linkData): linkData is Mapping =>
        isMapping(linkData) && linkData.key === key
    );
    if (mapping) {
      setDataProperty<Mapping>(model)(mapping, 'text', text);

      doMappingUpdated(mapping)(model);
    }

    // update link label
    const labelKey = getLabelKeyFromMappingKey(key);
    const labelData = model.nodeDataArray.find(
      (nodeData): nodeData is MappingLabel =>
        isMappingLabel(nodeData) && nodeData.key === labelKey
    );
    if (labelData) {
      setDataProperty<MappingLabel>(model)(labelData, 'text', text);
    }
  };
